import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-start justify-start my-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "input-label" }, [
  /*#__PURE__*/_createTextVNode("Czy po zabiegu/operacji nastąpiły powikłania? "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)
const _hoisted_3 = { class: "radio-group" }
const _hoisted_4 = { class: "radio-button form-radio-button" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, null, -1)
const _hoisted_6 = { class: "radio-button form-radio-button" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, null, -1)
const _hoisted_8 = { class: "error-message" }

import { useField } from 'vee-validate';


export default {
  __name: 'OperationsComplicationsField',
  setup(__props) {

const { value, errorMessage } = useField('hasOperationComplications');

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          name: "hasOperationComplications",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_isRef(value) ? (value).value = $event : null)),
          type: "radio",
          value: "yes"
        }, null, 512), [
          [_vModelRadio, _unref(value)]
        ]),
        _hoisted_5,
        _createTextVNode(" Tak ")
      ]),
      _createElementVNode("label", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          name: "hasOperationComplications",
          type: "radio",
          value: "no",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_isRef(value) ? (value).value = $event : null))
        }, null, 512), [
          [_vModelRadio, _unref(value)]
        ]),
        _hoisted_7,
        _createTextVNode(" Nie ")
      ])
    ]),
    _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(errorMessage)), 1)
  ]))
}
}

}